"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttendeePresenceFunc = getAttendeePresenceFunc;
var _underscore = _interopRequireDefault(require("underscore"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var debounceAttendeePresenceSetterMap = {};
/**
 * @param {*} attendeeId
 * @param {*} dispatch
 * @param {*} disconnectSource
 * @returns
 */
function getAttendeePresenceFunc(dispatch, actions, attendeeId) {
  var disconnectSource = actions.disconnectSource,
    setAttendeePresence = actions.setAttendeePresence;
  if (!debounceAttendeePresenceSetterMap[attendeeId]) {
    // We debounce (one debounce function per attendee) in hopes that when there is a health connection failure from chime
    // where the attendee presence changes rapidly from false to true, the UI will not be so reactive
    debounceAttendeePresenceSetterMap[attendeeId] = _underscore["default"].debounce(function (attendeeId, present) {
      return dispatch(setAttendeePresence(attendeeId, present, disconnectSource));
    }, 1000);
  }
  return debounceAttendeePresenceSetterMap[attendeeId];
}